export const NAME = 'core-router';
